import React from 'react';
import './InteractiveButton.scss';
import { ButtonProps, IconButton, Tooltip } from '@mui/material';
import styled from 'styled-components';

type Props = {
	disabled?: boolean;
	size?: 'small' | 'large';
	icon: React.ReactNode;
	hoverable?: 'default' | 'ring' | 'none';
	title?: string;
} & ButtonProps;

const IBUTTON = styled.div`
	&.interactive-button {
		.MuiIconButton-root {
			color: inherit;
			padding: 4px;
			border: 1px solid transparent;

			&.MuiIconButton-sizeSmall {
				font-size: 20px;
			}

			&.MuiIconButton-sizeLarge {
				font-size: 24px;
			}

			&.hoverable-default {
				&:not(.Mui-disabled):hover {
					background-color: var(--black-5);
				}

				&:not(.Mui-disabled):focus,
				&:not(.Mui-disabled):active {
					background-color: var(--black-10);
				}
			}

			&.hoverable-ring {
				&:not(.Mui-disabled):hover {
					border-color: rgba(255, 255, 255, 0.6);
				}

				&:not(.Mui-disabled):focus,
				&:not(.Mui-disabled):active {
					border-color: var(--white);
				}
			}

			&.hoverable-none {
				color: var(--black-40);
				&:not(.Mui-disabled):hover {
					color: var(--black-60);
				}

				&:not(.Mui-disabled):focus,
				&:not(.Mui-disabled):active {
					color: var(--black-60);
				}
			}

			&.Mui-disabled {
				color: var(--black-40);
				pointer-events: auto;
				cursor: not-allowed;
				opacity: 0.6;
			}
		}
	}
`;

const InteractiveButton = ({
	size = 'large',
	disabled,
	icon,
	hoverable = 'default',
	title,
	...rest
}: Props) => {
	return (
		<IBUTTON className='interactive-button'>
			<Tooltip title={!disabled && title ? title : ''}>
				<IconButton
					disableElevation={true}
					className={`hoverable-${hoverable}`}
					onMouseDown={(event) => event.preventDefault()}
					disableRipple
					disabled={disabled}
					size={size}
					{...rest}
				>
					{icon}
				</IconButton>
			</Tooltip>
		</IBUTTON>
	);
};

export default InteractiveButton;
